module.exports = __webpack_public_path__ + "img/Rel.Manager@3x.a0cd0a7f.png";